<div class="crop" [style.width.px]="cropWidth" [title]="rating">
  <div style="width: 75px; color: #ffd44c">
    <span class="fa fa-star"></span>
    <span class="fa fa-star"></span>
    <span class="fa fa-star"></span>
    <span class="fa fa-star"></span>
    <span class="fa fa-star"></span>
  </div>
</div>
